import { Icon, Touchable } from "@grassrootly/rn-core";
import { ImagePickerProps } from "./ImagePicker.types";
import { Image } from "react-native";
import { useImagePicker } from "./useImagePicker";
import { images } from "../../layout/assets";

export default function ImagePicker({
  source,
  onPicked,
  onCancel,
  classNames,
  resizeMode = "cover",
  base64 = true,
}: ImagePickerProps) {
  const { pickImage } = useImagePicker({ onPicked, base64 });
  return (
    <Touchable onPress={pickImage} classNames={classNames}>
      <Image style={{ height: 160, width: 160, borderRadius: 160 }} resizeMode={resizeMode} source={source} />
      {onCancel ? (
        <Touchable
          classNames={[
            "h-{40}",
            "w-{40}",
            "br-{40}",
            "absolute",
            "left-{20}",
            "bottom-{-4}",
            "bgDangerMain",
            "justifyContentCenter",
            "alignItemsCenter",
          ]}
          onPress={onCancel}
        >
          <Icon name="close" classNames={["colorNeutralLighterLight"]} size={24} />
        </Touchable>
      ) : null}
      <Image
        source={images.photoUpload}
        style={{ height: 40, width: 40, borderRadius: 40, position: "absolute", right: 20, bottom: -4 }}
        resizeMode="cover"
      />
    </Touchable>
  );
}
